<template>
  <Layout>
    <h1 class="h1">Instellingen</h1>
    <div class="overflow-x-scroll md:overflow-x-hidden">
      <div class="my-5 tabs">
        <router-link
          v-for="link in links"
          :key="link.name"
          :to="link.to"
          class="tab"
          active-class="active"
          exact
        >{{ link.name }}</router-link>
        <div class="tab-remainder"></div>
      </div>
    </div>
    <div class="mb-8 mt-4">
      <router-view></router-view>
    </div>
  </Layout>
</template>

<script>
const LINKS = [
  { name: "Mijn gegevens", to: "/settings/me" },
  { name: "Gebruikers", to: "/settings/users" },
  { name: "Soorten", to: "/settings/statuses" },
  { name: "Fases", to: "/settings/phases" },
  { name: "Contactgegevens", to: "/settings/fields" },
  { name: "Eigen velden", to: "/settings/customfields" },
  { name: "Tags", to: "/settings/tags" }
];
export default {
  metaInfo() {
    return { title: "Instellingen" };
  },

  data() {
    return {
      links: LINKS
    };
  }
};
</script>
